import { connect } from 'react-redux';

import {
  getCurrentCommits,
  getCurrentCommitGraph,
  getCurrentPage,
  getStartPage,
  getCommitList,
} from 'src/redux/commit-list';
import { BucketState } from 'src/types/state';

import CommitListWithKeyboardShortcuts from '../components/commit-list-with-keyboard-shortcuts';

const mapStateToProps = (state: BucketState) => ({
  commits: getCurrentCommits(state),
  commitGraphElements: getCurrentCommitGraph(state),
  currentPage: getCurrentPage(state),
  isLoading: state.repository.commitList.isLoading,
  isPreRequestState: state.repository.commitList.isPreRequestState,
  startPage: getStartPage(state),
  newCommits: getCommitList(state).newCommits,
});

export default connect(mapStateToProps)(CommitListWithKeyboardShortcuts);
